<script>
  export let job
</script>

<div class="ml-2 mt-2">
  <p class="font-bold">{job.name}</p>
  <ul class="list-inside list-disc decoration-dark-blue">
    {#each job.achievements as a}
      <li>{a}</li>
    {/each}
  </ul>
</div>
